<h1>{{ this.currentTitle }}</h1>

<div class="teams-list">
  <table class="table">
    <thead>
    <tr>
      <th>{{ 'teams.invite.team_name' | translate }}</th>
      <th>{{ 'teams.invite.action' | translate }}</th>
    </tr>
    </thead>
    <tbody>
      @for (team of teamsList(); track team.team_id) {
        <tr>
          <td class="team-name">{{ team.team_name }}</td>
          <td class="action">
            <button (click)="copyToClipboard(invitationLink(team.team_id))" nbButton fullWidth status="primary">{{ 'teams.invite.copy_link' | translate }}</button>
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>
